import { HOC } from 'formsy-react';

import Input from './index';

export default HOC(Input);



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/RatingInput/Formsy.jsx